// useSearchTabs.js
import { useState, useEffect } from 'react';
import useWordInURL from './useWordInURL';
import { ROUTE_KEYS } from 'frontend/constants';

const { BUSCAR_X_PAQUETES, BUSCAR_X_VUELOS } = ROUTE_KEYS;

export const useSearchTabs = ({ enableSearchPackage, enableSearchFlights }) => {
  const [value, setValue] = useState(0);
  const isFlightSearch = useWordInURL(BUSCAR_X_VUELOS);
  const isPackageSearch = useWordInURL(BUSCAR_X_PAQUETES);

  useEffect(() => {
    if (isFlightSearch) {
      setValue(1);
    } else if (isPackageSearch) {
      setValue(0);
    }
  }, [isFlightSearch, isPackageSearch]);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };

  const getTabStyle = (isEnabled, borderRadius, marginRight = 0) => ({
    backgroundColor: 'white',
    borderTopLeftRadius: borderRadius.left,
    borderTopRightRadius: borderRadius.right,
    minHeight: '50px',
    minWidth: '130px',
    marginRight,
    display: isEnabled ? 'inline-block' : 'none',
  });

  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  });

  return {
    value,
    handleChange,
    getTabStyle,
    a11yProps,
    shouldRender: enableSearchPackage || enableSearchFlights,
  };
};
